import "./style.css"

<let/activeFilter="All"/>

<const/projects=input.projects/>
<const/filters=["All", "Web", "Arduino"]/>
<const/filtered=projects.filter(function(p) {
  if (activeFilter === 'All') return true;
  if (activeFilter === 'Web') return p.project_type === 'web';
  if (activeFilter === 'Arduino') return p.project_type === 'arduino';
  return true;
})/>

<div class="projects-page section-container">
  <h2>Projects</h2>

  <div class="filter-tabs" role="tablist">
    <for|filter| of=filters>
      <button
        role="tab"
        aria-selected=(activeFilter === filter)
        class=`filter-tab ${activeFilter === filter ? 'filter-tab--active' : ''}`
        onClick() { activeFilter = filter; }
      >
        ${filter}
      </button>
    </for>
  </div>

  <div class="projects-grid">
    <for|project| of=filtered>
      <project-card ...project />
    </for>
  </div>
</div>
